import Order from "../models/Order";
import OrderContact from "../models/OrderContact";
import OrderLocation from "../models/OrderLocation";
import OrderNote from "../models/OrderNote";
import InsulationCut from "../models/InsulationCut";
import OrderItem from "../models/OrderItem";
import Note from "../models/Note";
import OrderStatus from "../models/OrderStatus";
import OrderStatusLog from "../models/OrderStatusLog";
import Product from "../models/Product";
import Contact from "../models/Contact";
import Location from "../models/Location";
import Customer from "../models/Customer";
import Carrier from "../models/Carrier";
import CarrierContact from "../models/CarrierContact";
import CarrierLocation from "../models/CarrierLocation";
import OrderCommit from "../models/OrderCommit";

export default class OrderRetrieve {

  constructor(order_id) {
    this.order_id = order_id;
    this.order = null;
  }

  fetch() {
    this.populate();
    if(this.order && this.order_id) {
      return new Promise(resolve => {
        return OrderCommit.api().fetch({order_id: this.order_id, limit: 1, pending: true}).then(() => {
          this.order.order_commits = OrderCommit.query().where('order_id', +(this.order_id)).get();
          return resolve(this.order);
        });
      });
    }
    return Promise.all([
      Product.api().fetch({limit: 9999}),
      OrderItem.api().fetch({order_id: this.order_id, limit: 9999}),
      OrderStatusLog.api().fetch({order_id: this.order_id, limit: 9999}),
      OrderContact.api().fetch({order_id: this.order_id, limit: 9999}),
      OrderLocation.api().fetch({order_id: this.order_id, limit: 9999}),
      OrderNote.api().fetch({order_id: this.order_id, limit: 9999}),
      OrderStatus.api().fetch(),
      OrderCommit.api().fetch({order_id: this.order_id, limit: 1, pending: true}),
      Order.api().retrieve(this.order_id),
    ]).then((results) => {

      let entities = {};
      results.forEach((result) => {
        for(let i in result.entities) {
          entities[i] = result.entities[i];
        }
      });

      let items = entities.order_items ? entities.order_items : [];
      let cuts = [];
      if(items && items.length) {
        items.forEach((item) => {
          if(item.insulation_cut_id) {
            cuts.push(item.insulation_cut_id);
          }
        });
      }

      let order_contacts = entities.order_contacts ? entities.order_contacts : [];
      let contacts = [];
      if(order_contacts && order_contacts.length) {
        order_contacts.forEach((order_contact) => {
          if(order_contact.contact_id) {
            contacts.push(order_contact.contact_id);
          }
        });
      }

      let order_locations = entities.order_locations ? entities.order_locations : [];
      let locations = [];
      if(order_locations && order_locations.length) {
        order_locations.forEach((order_location) => {
          if(order_location.location_id) {
            locations.push(order_location.location_id);
          }
        });
      }

      let order_notes = entities.order_notes ? entities.order_notes : [];
      let notes = [];
      if(order_notes && order_notes.length) {
        order_notes.forEach((order_note) => {
          if(order_note.note_id) {
            notes.push(order_note.note_id);
          }
        });
      }

      let order = entities.orders ? entities.orders[0] : null;

      let p = [
        Customer.api().retrieve(order.customer_id),
        InsulationCut.api().fetch({id: cuts.join('|')}),
        Contact.api().fetch({id: contacts.join('|')}),
        Location.api().fetch({id: locations.join('|')}),
        Note.api().fetch({id: notes.join('|')})
      ];

      if(order) {
        if(order.customer_id) {
          p.push(Customer.api().retrieve(order.customer_id));
        }
        if(order.carrier_id) {
          p.push(Carrier.api().retrieve(order.carrier_id));
          p.push(CarrierContact.api().fetch({carrier_id : order.carrier_id}));
          p.push(CarrierLocation.api().fetch({carrier_id : order.carrier_id}));
        }
      }

      return Promise.all(p).then((inner_results) => {

        let entities = {};
        inner_results.forEach((inner_result) => {
          for(let i in inner_result.entities) {
            entities[i] = inner_result.entities[i];
          }
        });

        let c_p = [];

        if(entities.carrier_contacts && entities.carrier_contacts.length) {
          let c_contacts = [];
          entities.carrier_contacts.forEach((carrier_contact) => {
            if (carrier_contact.contact_id) {
              c_contacts.push(carrier_contact.contact_id);
            }
          });
          c_p.push(Contact.api().fetch({id: c_contacts.join('|')}));
        }

        if(entities.carrier_locations && entities.carrier_locations.length) {
          let c_locations = [];
          entities.carrier_locations.forEach((carrier_location) => {
            if (carrier_location.contact_id) {
              c_locations.push(carrier_location.contact_id);
            }
          });
          c_p.push(Location.api().fetch({id: c_locations.join('|')}));
        }

        return Promise.all(c_p)

      });

    });
  }

  populate() {
    return this.order = Order.query().whereId(+(this.order_id)).with([
      'customer',
      'documents',
      'carrier.carrier_contacts.contact',
      'carrier.carrier_locations.location',
      'order_items.product.images',
      'order_items.product.specifications',
      'order_items.insulation_cut',
      'order_contacts.contact',
      'order_locations.location',
      'order_notes.note',
      'order_status_logs.order_status',
      'order_commits'
    ]).first();
  }

}